import request from '@/utils/request'
import { workbenchServiceDict } from '@/dictionary/system'
import store from '@/store'
import { addQueryToUrl } from '@/utils/utils'

const PURCHASE_API = process.env.VUE_APP_PURCHASE_API

function getPlatformAlias() {
  return workbenchServiceDict.array.find(
    item => item.value === store.state.router.currentWorkbench
  ).platformAlias
}

/**
 * 导入评审办法
 */
export function importPurchaseReviewListApi(data) {
  return request(
    {
      url: PURCHASE_API + '/workbench/purchaser/purchase-reviews/ways/import',
      method: 'post',
      data,
      headers: { 'Content-Type': 'multipart/form-data' }
    },
    true,
    true
  )
}

/**
 * 导出评审办法
 */
export function exportPurchaseReviewListApi(params) {
  const alias = getPlatformAlias()
  return (
    PURCHASE_API +
    `/workbench/purchaser/purchase-reviews/${params.reviewId}/ways/export?identity=${alias}`
  )
}

/**
 * 新增评审单
 */
export function addPurchaseReviewApi(reviewId, data) {
  if (reviewId) {
    return request({
      url: PURCHASE_API + `/workbench/purchaser/purchase-reviews/${reviewId}`,
      method: 'put',
      data
    })
  }
  return request({
    url: PURCHASE_API + '/workbench/purchaser/purchase-reviews',
    method: 'post',
    data
  })
}

/**
 * 发布评审单
 */
export function releasePurchaseReviewApi(reviewId, data) {
  if (reviewId) {
    return request({
      url:
        PURCHASE_API +
        `/workbench/purchaser/purchase-reviews/${reviewId}/release`,
      method: 'put',
      data
    })
  }
  return request({
    url: PURCHASE_API + '/workbench/purchaser/purchase-reviews/release',
    method: 'post',
    data
  })
}

/**
 * 查询评审详情
 */
export function getPurchaseReviewDetailApi(reviewId) {
  return request({
    url:
      PURCHASE_API + `/workbench/purchaser/purchase-reviews/${reviewId}/detail`,
    method: 'get'
  })
}

/**
 * 设置评审的专家打分模式
 */
export function setPurchaseReviewerModeApi(reviewId, data) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/setting/score-way`,
    method: 'put',
    data
  })
}

/**
 * 直接组建评委专家
 */
export function setUpPurchaseReviewerListApi(reviewId, data) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/reviewers/form`,
    method: 'post',
    data
  })
}

/**
 * 同步抽取结果并组建专家
 */
export function syncPurchaseExtractReviewerApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/reviewers/form-extract`,
    method: 'post',
    params
  })
}

/**
 * 从历史项目中复制专家
 */
export function copyPurchaseReviewerFromHistoryApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/reviewers/form-old`,
    method: 'post',
    params
  })
}

/**
 * 修改评委专家信息
 */
export function changePurchaseReviewerApi(reviewId, reviewerId, data) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/reviewers/${reviewerId}/info`,
    method: 'put',
    data
  })
}

/**
 * 移除评审专家
 */
export function removePurchaseReviewerApi(reviewId, reviewerId) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/reviewers/${reviewerId}/remove`,
    method: 'put'
  })
}

/**
 * 重置评审专家密码
 */
export function resetPurchaseReviewerPasswordApi(reviewId, reviewerId, data) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/reviewers/${reviewerId}/reset-password`,
    method: 'put',
    data
  })
}

/**
 * 重置所有评审专家的密码，并返回密码
 */
export function resetPurchaseReviewerAllPasswordApi(reviewId) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/reviewers/reset-password`,
    method: 'put'
  })
}

/**
 * 查询评审明细信息
 */
export function getPurchaseReviewItemInfoAPi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/item-scores/list`,
    method: 'get',
    params
  })
}

/**
 * 获取某个评审办法下供应的打分汇总列表
 */
export function getPurchaseReviewItemSupplierScoreApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/supplier-scores/page`,
    method: 'get',
    params
  })
}

/**
 * 查询所有专家汇总信息
 */
export function getPurchaseReviewExpertSummaryPageApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/score-summaries/page`,
    method: 'get',
    params
  })
}

/**
 * 查询供应商的打分详情
 */
export function getPurchaseReviewSupplierScoreDetailApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/way-scores/detail`,
    method: 'get',
    params
  })
}

/**
 * 导出打分表
 */
export function exportPurchaseReviewScoreApi(reviewId, params) {
  window.open(
    addQueryToUrl(
      `${PURCHASE_API}/workbench/purchaser/purchase-reviews/${reviewId}/way-scores/export`,
      { wayId: params.wayId, identity: getPlatformAlias() }
    ),
    '_blank'
  )
}

/**
 * 导入打分表
 */
export function importPurchaseReviewScoreApi(reviewId, params, data) {
  return request(
    {
      url: addQueryToUrl(
        `${PURCHASE_API}/workbench/purchaser/purchase-reviews/${reviewId}/way-scores/import`,
        params,
        false
      ),
      method: 'post',
      data,
      headers: { 'Content-Type': 'multipart/form-data' }
    },
    true,
    true
  )
}

/**
 * 采购人提交打分
 */
export function submitPurchaseReviewScoreApi(reviewId, data, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/way-scores/submit`,
    method: 'post',
    data,
    params
  })
}

/**
 * 汇总评审办法的打分信息
 */
export function submitPurchaseReviewSummaryApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/way-scores/summary`,
    method: 'post',
    params
  })
}

/**
 * 最低价汇总评审办法
 */
export function submitPurchaseReviewByQuoteSummaryApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/inquiry-reviews/${reviewId}/way-scores/summary`,
    method: 'post',
    params
  })
}

/**
 * 查询评审办法下所有专家的打分情况
 */
export function getPurchaseReviewExpertScoreListApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/reviewer-summaries/list`,
    method: 'get',
    params
  })
}

/**
 * 采购人完成打分
 */
export function completePurchaseReviewScoreApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/way-scores/complete`,
    method: 'post',
    params
  })
}

/**
 * 评审办法重评
 */
export function reStartPurchaseReviewWayApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API + `/workbench/purchaser/purchase-reviews/${reviewId}/again`,
    method: 'post',
    params
  })
}

/**
 * 终止评审
 */
export function stopPurchaseReviewApi(reviewId) {
  return request({
    url:
      PURCHASE_API + `/workbench/purchaser/purchase-reviews/${reviewId}/close`,
    method: 'post'
  })
}

/**
 * 完成评审
 */
export function completePurchaseReviewApi(reviewId, data) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/complete`,
    method: 'post',
    data
  })
}

/**
 * 重新评审
 */
export function reStartPurchaseReviewApi(reviewId) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/restart`,
    method: 'post'
  })
}

/**
 * 报告上传
 */
export function uploadPurchaseReviewReportApi(reviewId, data) {
  return request(
    {
      url:
        PURCHASE_API +
        `/workbench/purchaser/purchase-reviews/${reviewId}/reports/upload`,
      method: 'post',
      data
    },
    false
  )
}

/**
 * 完成报告上传
 */
export function completePurchaseReviewReportApi(reviewId) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/reports/complete`,
    method: 'post'
  })
}

/**
 * 下载报告
 */
export function downloadPurchaseReviewReportApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/reports/down`,
    method: 'get',
    params
  })
}

/**
 * 合并报告下载
 */
export function downloadMergePurchaseReviewReportApi(reviewId, params) {
  window.open(
    addQueryToUrl(
      `${PURCHASE_API}/workbench/purchaser/purchase-reviews/${reviewId}/reports/merge-down`,
      { ...params, identity: getPlatformAlias() }
    ),
    '_blank'
  )
}

/**
 * 提交供应商报价折扣率
 */
export function submitPurchaseReviewSupplierQuoteRateApi(reviewId, data) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/supplier-rate/submit`,
    method: 'post',
    data
  })
}

/**
 * 查询供应商报价折扣率列表
 */
export function getPurchaseReviewSupplierQuoteListApi(reviewId) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/supplier-rates`,
    method: 'get'
  })
}

/**
 * 开启价格分评审
 */
export function startPurchaseReviewQuoteReviewApi(reviewId) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/purchase-reviews/${reviewId}/offer-score/start`,
    method: 'post'
  })
}
